var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-page"},[(_vm.$route.name === 'candidate.results')?_c('Header'):_vm._e(),_c('main',{staticClass:"inner-page__content align-items-stretch p-0"},[_c('div',{staticClass:"exam w-100"},[_c('Sidebar'),_c('TransitionTemplate',[_c('router-view')],1)],1)]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }